import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";

import configureStore from "./configureStore";
import MuiTheme from "./muiTheme";
import MuiThemeAdmin from "./muiThemeAdmin";
import { IS_ADMIN_APP } from "./utils/stateTypes";

//Code splitting between admin and user components
const App = React.lazy(() => import("./components/App"));
const AdminApp = React.lazy(() => import("./adminComponents/AdminApp"));


let store = configureStore();

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");

const root = createRoot(rootElement);
root.render(
  <BrowserRouter basename={baseUrl}>
    <Provider store={store}>
      <ThemeProvider theme={IS_ADMIN_APP ? MuiThemeAdmin : MuiTheme}>
        <React.Suspense fallback={null}>
          {IS_ADMIN_APP ? <AdminApp /> : <App />}
        </React.Suspense>
      </ThemeProvider>
    </Provider>
  </BrowserRouter>,
);
